import { useContext, useMemo } from "react";
import { cloneDeep, merge } from "lodash";
import { ThemeContext } from "styled-components";
import { getLightTheme } from "@glossy/theme/templates";
import { GlossyTheme, PartialTheme } from "./types";

export {
  background,
  border,
  chart,
  content,
  dominant,
  evolution,
  form,
  message,
  onDominant,
} from "./mixins";

const defaultTheme = getLightTheme();

export const mixThemes = (
  theme: PartialTheme,
  overload: PartialTheme
): GlossyTheme =>
  merge(cloneDeep(defaultTheme), cloneDeep(theme), cloneDeep(overload));

export const useTheme = () => useContext(ThemeContext) || defaultTheme;

/* eslint-disable react-hooks/rules-of-hooks */
export const generateTheme = (theme: PartialTheme): GlossyTheme => {
  const previousTheme = useTheme();
  return useMemo(() => mixThemes(previousTheme, theme), [theme, previousTheme]);
};
